///
/// Vuex Module - Application
///

import Vue from 'vue'
import { API } from '@/lib/api'
import * as types from '../types'

/// STATE
const state = () => ({
	resource: {},
	resources: [],
})

/// ACTIONS
const actions = {
	async create({ commit, dispatch }, data) {
		let resource
		try {
			resource = await API.send(`/resources`, data)
			commit(types.SET_RESOURCE, resource)
		} catch (error) {
			this.dispatch('misc/setError', error)
			throw new Error(error.message || error)
		}

		return resource
	},
	async list({ commit }, params) {
		this.dispatch('misc/setLoading', true)

		let resources
		try {
			resources = await API.get(`/resources`, params)
			commit(types.SET_RESOURCES, resources)
			this.dispatch('misc/setLoading', false)
		} catch (error) {
			this.dispatch('misc/setError', error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return resources
	},
	async get({ commit }, resourceId) {
		let resource
		try {
			resource = await API.get(`/resources/${resourceId}`)
			commit(types.SET_RESOURCE, resource)
		} catch (error) {
			this.dispatch('misc/setError', error)
			throw new Error(error.message || error)
		}

		return resource
	},
	async update({ commit }, { resourceId, data }) {
		let resource
		try {
			resource = await API.update(`/resources/${resourceId}`, data)
			commit(types.SET_RESOURCE, resource)
		} catch (error) {
			this.dispatch('misc/setError', error)
			throw new Error(error.message || error)
		}
	},
	async unset({ commit }) {
		commit(types.UNSET_RESOURCE)
	},
	async requestInfo({ commit }, resourceId) {
		this.dispatch('misc/setLoading', true)

		let request
		try {
			request = await API.send(`/resources/${resourceId}/request`)
			this.dispatch('misc/setLoading', false)
		} catch (error) {
			this.dispatch('misc/setError', error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return request
	},
	async requestSupport({ commit }, { resourceId, message }) {
		this.dispatch('misc/setLoading', true)

		let request
		try {
			request = await API.send(`/resources/${resourceId}/support`, { message })
			this.dispatch('misc/setLoading', false)
		} catch (error) {
			this.dispatch('misc/setError', error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return request
	},
}
/// MUTATIONS
const mutations = {
	[types.SET_RESOURCES](state, resources) {
		state.resources = [
			...resources,
		]
	},
	[types.SET_RESOURCE](state, resource) {
		state.resource = { ...resource }

		const idx = state.resources.findIndex(a => a.resourceId == resource.resourceId)
		if (idx > -1) {
			state.resources[idx] = resource
		} else {
			state.resources.push(resource)
		}
		Vue.set(state, 'resources', [...state.resources] )
	},
	[types.UNSET_RESOURCE](state) {
		state.resource = {}
	},
}

/// GETTERS
const getters = {
	resources: state => state.resources,
	resource: state => state.resource,
}

/// EXPORT
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
